import axios from "../../config/axiosConfig";
import {
  UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_REQUEST,
  UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_SUCCESS,
  UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_FAILURE
} from "../types/unadjust-bill-cash-payment-report-types";

export const getUnadjustBillCashPaymentRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params?.fromDate);
      console.log('params.toDate',params?.toDate);
      
      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        // selectedBills: params?.selectedBills, 
        // selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // If 'selectedBook' exists and is an array, convert it to a comma-separated string
      // if (Array.isArray(requestParams.selectedBook)) {
      //   requestParams.selectedBook = requestParams.selectedBook.join(',');
      // }

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/unadjustment-cash-payment-report/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Cash Register Report:", error);
        dispatch({ type: UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Cash Register Report:", error);
      dispatch({ type: UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearUnadjustBillCashPaymentRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: UNADJUST_BILL_CASH_PAYMENT_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}
